export default __webpack_public_path__ + "static/media/community.257512f9.md";